import React, { useEffect, useState, useRef } from 'react';
import { LinkedinIcon, YoutubeIcon, ChevronRightIcon } from 'lucide-react';
export interface Guest {
  name: string;
  title?: string;
  linkedinUrl: string;
  imageUrl: string;
  episodeUrl?: string;
  imagePosition?: string;
}
interface GuestCardProps {
  guest: Guest;
}
const GuestCard = ({
  guest
}: GuestCardProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    }, {
      threshold: 0.2
    });
    if (cardRef.current) {
      observer.observe(cardRef.current);
    }
    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);
  return <div ref={cardRef} className="group relative" data-id="element-12">
      <div className="absolute inset-0 bg-gradient-to-b from-green-500/10 to-emerald-500/10 -m-0.5 blur-md transition-all duration-500 group-hover:blur-lg group-hover:opacity-70" data-id="element-13"></div>
      <div className="relative bg-gray-900/90 rounded overflow-hidden transition-all duration-500 group-hover:transform group-hover:scale-[1.02] border border-green-500/20 group-hover:border-green-500/40 shadow-lg" data-id="element-14">
        <div className="aspect-square overflow-hidden relative" data-id="element-15">
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-16"></div>
          <img src={guest.imageUrl} alt={`${guest.name}`} style={guest.imagePosition ? {
          objectPosition: guest.imagePosition
        } : undefined} className={`
              w-full h-full object-cover transition-all duration-700
              md:grayscale md:group-hover:grayscale-0 md:group-hover:scale-110
              grayscale ${isVisible ? 'grayscale-0' : ''} 
            `} data-id="element-17" />
        </div>
        <div className="p-3 relative space-y-2" data-id="element-18">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-px bg-gradient-to-r from-transparent via-green-500/50 to-transparent" data-id="element-19"></div>
          <div className="text-center space-y-0.5" data-id="element-20">
            <h3 className="text-sm font-bold truncate px-1" data-id="element-21">{guest.name}</h3>
            {guest.title && <p className="text-xs text-gray-400 truncate px-1" data-id="element-22">
                {guest.title}
              </p>}
          </div>
          <div className="flex justify-center items-center gap-1.5" data-id="element-23">
            <a href={guest.episodeUrl || '#'} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-red-400 hover:text-red-300 transition-colors px-1.5 py-0.5 rounded-full border border-red-500/30 hover:border-red-500/50 text-[10px]" data-id="element-24">
              <YoutubeIcon className="w-2.5 h-2.5 mr-0.5" data-id="element-25" />
              <span data-id="element-26">Episode</span>
            </a>
            <a href={guest.linkedinUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-green-400 hover:text-green-300 transition-colors px-1.5 py-0.5 rounded-full border border-green-500/30 hover:border-green-500/50 text-[10px]" data-id="element-27">
              <LinkedinIcon className="w-2.5 h-2.5 mr-0.5" data-id="element-28" />
              <span data-id="element-29">Profile</span>
            </a>
          </div>
          <button className="w-full flex items-center justify-center text-green-500 hover:text-green-400 transition-colors text-[10px] font-medium pt-0.5" data-id="element-30">
            <span data-id="element-31">Read More</span>
            <ChevronRightIcon className="w-2.5 h-2.5 ml-0.5" data-id="element-32" />
          </button>
        </div>
      </div>
    </div>;
};
export default GuestCard;